/* tslint:disable */
/* eslint-disable */
/**
 * partnerDriverWeb driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const DriverRegistrationLogStep = {
        STEP1: 'step_1',
        STEP2: 'step_2',
        STEP3: 'step_3',
        STEP4: 'step_4',
        STEP5: 'step_5',
        STEP6: 'step_6'
} as const;
export type DriverRegistrationLogStep = typeof DriverRegistrationLogStep[keyof typeof DriverRegistrationLogStep];

